// Module
var code = "<div class=bible> <h2 class=passageref>1 Kings 12.19</h2> <div class=bibletext> <p> <sup class=ww>19</sup>So Israel has been in rebellion against the house of David to this day. </p> </div></div>";
// Exports
module.exports = code;